import { render, staticRenderFns } from "./login.component.vue?vue&type=template&id=f164a2da&scoped=true"
import script from "./login.component.vue?vue&type=script&lang=ts"
export * from "./login.component.vue?vue&type=script&lang=ts"
import style0 from "./login.component.vue?vue&type=style&index=0&id=f164a2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f164a2da",
  null
  
)

export default component.exports